// src/hooks/useIsOwner.js
import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';

export default function useIsOwner() {
  const [isOwner, setIsOwner] = useState(false);
  const { chatId } = useParams();   // ✅ only here, not reused

  useEffect(() => {
    if (typeof window !== 'undefined' && window.__IS_OWNER__ !== undefined) {
      setIsOwner(window.__IS_OWNER__);
      return;
    }

    if (!chatId) return;

    fetch(`/api/chats/${chatId}/is-owner`, {
      credentials: 'include'
    })
      .then(res => res.ok ? res.json() : { isOwner: false })
      .then(data => setIsOwner(data.isOwner ?? false))
      .catch(() => setIsOwner(false));
  }, [chatId]);

  return isOwner;
}
